import {DefaultTheme} from "styled-components";
import BaseTheme from "@fkhplus/common/src/styles/themes/Base";
import Secondary from "@fkhplus/common/src/styles/themes/Secondary";
import {IThemes} from "@fkhplus/common/src/styles/themes/interface";

class Themes {
    private _baseTheme: DefaultTheme = BaseTheme;
    private _themes: IThemes = {default: BaseTheme, secondary: Secondary};
    private themesConstant: DefaultTheme[] = [BaseTheme];

    constructor() {
        this.themes = this.loadThemes();
    }

    public loadThemes = (): IThemes => {
        const themes: IThemes = this.themes;
        this.themesConstant.map((theme) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            themes[theme['name']] = theme;

        });
        return <IThemes>themes;
    }

    public getThemeByName = (name: string): DefaultTheme => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return this.themes[name];
    }

    get themes(): IThemes {
        return this._themes;
    }

    set themes(value: IThemes) {
        this._themes = value;
    }

    get baseTheme(): DefaultTheme {
        return this._baseTheme;
    }

    set baseTheme(value: DefaultTheme) {
        this._baseTheme = value;
    }
}

const themes = new Themes();
export {themes as Themes};